import React, { useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../../layout/Layout";
import PageBanner from "../../layout/PageBanner";
import { authService } from "../../services";
import { Panel, TextField } from "../../components/ui";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    if (!email) return setError("กรุณากรอกอีเมล");
    setLoading(true);
    try {
      await authService.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <PageBanner title="ลืมรหัสผ่าน" breadcrumb={[{ label: "ลืมรหัสผ่าน" }]} seed={14} />
      <div className="lucid-container" style={{ marginTop: -70, position: "relative", zIndex: 3, paddingBottom: 40 }}>
        <Panel style={{ maxWidth: 620, margin: "0 auto" }}>
          <h2 className="lt-panel__title lt-mb-24">รีเซ็ตรหัสผ่าน</h2>
          {sent ? (
            <>
              <p>ส่งลิงก์รีเซ็ตรหัสผ่านไปที่ {email} เรียบร้อยแล้ว กรุณาตรวจสอบกล่องจดหมาย</p>
              <Link to="/login" className="lt-btn lt-btn--teal lt-btn--block lt-mt-24">
                กลับไปหน้าเข้าสู่ระบบ
              </Link>
            </>
          ) : (
            <form onSubmit={submit}>
              <TextField
                label="อีเมล"
                type="email"
                placeholder="กรอกอีเมลที่ใช้สมัคร"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
              {error ? <p className="lt-helper lt-helper--danger">{error}</p> : null}
              <button type="submit" className="lt-btn lt-btn--teal lt-btn--block" disabled={loading}>
                {loading ? "กำลังส่ง..." : "ส่งลิงก์รีเซ็ตรหัสผ่าน"}
              </button>
            </form>
          )}
        </Panel>
      </div>
    </Layout>
  );
}
